import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "../pages/login/Login";
import Lobby from "../pages/lobby/Lobby";
import Observe from "../pages/observe/Observe";
import OneVehicle from "../pages/onevehicle/OneVehicle";
import FourVehicle from "../pages/fourvehicle/FourVehicle";
import MasterLayout from "../pages/master/MasterLayout";
import BpsLog from "../pages/bpslog/BpsLog";
import BpsLogMapPage from "../pages/bpslog/BpsLogMapPage";
import MqttLog from "../pages/mqttlog/MqttLog";

const LocationLogger: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    console.log(`Version: ${import.meta.env.VITE_APP_VERSION}`);
  }, [location]);

  return null;
};

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <LocationLogger />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/lobby" element={<Lobby />} />
        <Route path="/observe" element={<Observe />} />
        <Route path="/onevehicle" element={<OneVehicle />} />
        <Route path="/fourvehicle" element={<FourVehicle />} />
        <Route path="/master/*" element={<MasterLayout />} />
        <Route path="/bpslog" element={<BpsLog />} />
        <Route path="/bpslog/map" element={<BpsLogMapPage />} />
        <Route path="/rabbitmq-trace-log" element={<MqttLog />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
